import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { StripeConnectPaymentIntent } from 'src/app/shared/api/models';

declare var Stripe: any;

@Component({
  selector: 'app-stripe-checkout',
  templateUrl: './stripe-checkout.component.html',
  styleUrls: ['./stripe-checkout.component.css'],
})
export class StripeCheckoutComponent implements OnInit, AfterViewInit {
  @Input() paymentIntent: StripeConnectPaymentIntent;
  @Input() documentName: Observable<string>;
  @ViewChild('cardInfo') cardInfo: ElementRef;

  cardHandler = this.onChange.bind(this);
  elements: any;
  error: string | null;
  loading = false;
  paymentElement: any;
  stripe: any;

  constructor(
    public activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService,
  ) {}

  ngOnDestroy() {
    this.paymentElement.removeEventListener('change', this.cardHandler);
    this.paymentElement.destroy();
  }

  ngOnInit(): void {
    this.stripe = Stripe(this.paymentIntent.publicKey);
  }

  ngAfterViewInit() {
    const appearance = { theme: 'stripe' };
    const { clientSecret } = this.paymentIntent;

    this.elements = this.stripe.elements({ appearance, clientSecret });

    this.paymentElement = this.elements.create('payment');
    this.paymentElement.mount('#payment-element');

    this.paymentElement.addEventListener('change', this.cardHandler);
  }

  onChange({ error }) {
    if (error) {
      this.error = error.message;
    } else {
      this.error = null;
    }

    this.loading = false;
    this.cdr.detectChanges();
  }

  async onPay() {
    this.loading = true;

    const { error } = await this.stripe.confirmPayment({
      elements: this.elements,
      confirmParams: {
        return_url: window.location.href,
      },
      // redirect: 'if_required', // turn on to handle response paymentIntent manually when no redirect happens
    });

    if (error.type === 'card_error' || error.type === 'validation_error') {
      this.error = error.message;
    } else {
      this.error = this.translate.instant(
        'stripe-checkout.generic-error-message',
      );
    }

    this.loading = false;
    this.cdr.detectChanges();
  }
}
